import { Component } from '@angular/core';

@Component({
  templateUrl: '../../../../../../assets/images/toastSuccess.svg',
})
export class ToastSuccessComponent { }
